import { DatasetMetadata, DatasetType, DefaultFilesUploadConfig, FileDatasetMetadata, OnlineStorage, PicsConfig, PictureDatasetMetadata } from "@tblabs/storage";
import { RefString, TextInput, Snack, Select, Ref } from "@tblabs/truffle";
import { Panel } from "../Components/Panel";
import { PrimaryButton } from "../Components/PrimaryButton";
import { Page } from "./Page";
import { Row } from "../Components/Row";
import { JsonEditor } from "../Components/JsonEditor";


export class AddDatasetPage extends Page
{
    constructor(private _storage: OnlineStorage)
    {
        super("Dataset creation");

        const metadataPresets = {
            [DatasetType.File]: {
                Type: DatasetType.File,
                CreatedAt: new Date(),
                CreatedBy: _storage.User.Id,
                Config: new DefaultFilesUploadConfig()
            } as FileDatasetMetadata,

            [DatasetType.Object]: {
                Type: DatasetType.Object,
                CreatedAt: new Date(),
                CreatedBy: _storage.User.Id
            } as DatasetMetadata,

            [DatasetType.Text]: {
                Type: DatasetType.Text,
                CreatedAt: new Date(),
                CreatedBy: _storage.User.Id
            } as DatasetMetadata,

            [DatasetType.Picture]: {
                Type: DatasetType.Text,
                CreatedAt: new Date(),
                CreatedBy: _storage.User.Id,
                Config: {
                    KeepSource: false,
                    Sizes: { "big": { ResizeToWidth: 1024 }, "small": { ResizeToWidth: 256 } }
                } as PicsConfig
            } as PictureDatasetMetadata,
        }

        this.Content(async () =>
        {
            const datasetType = new Ref<DatasetType>(DatasetType.Object);
            const datasetName = new RefString();
            const config = new RefString();

            datasetType.OnChange(v =>
            {
                config.value = JSON.stringify(metadataPresets[v], null, 2);
            }, true);

            this.body.Append(
                new Panel("Dataset creation", [
                    new Row(
                        new Select(datasetType, {
                            "Object dataset": DatasetType.Object,
                            "Text dataset": DatasetType.Text,
                            "Picture dataset": DatasetType.Picture,
                            "File dataset": DatasetType.File,
                        }).Class("white"),
                        new TextInput(datasetName).Placeholder("Dataset name"),
                    ),
                    new JsonEditor(config).Rows(12).Placeholder("Metadata").MarginTop(8),
                    new PrimaryButton("Create")
                        .EnableWhen(datasetName, v => v.toString().length > 0)
                        .OnClick(() => this.CreateDataset(datasetName, config)).MarginTop(12),
                ]),
            );
        });
    }

    private async CreateDataset(datasetName: RefString, config: RefString): Promise<void>
    {
        try
        {
            const name = datasetName.value;
            const metadata = JSON.parse(config.value);
            await this._storage.CreateDataset(name, metadata);

            new Snack("✅ Dataset created");

            const datasetType = JSON.parse(config.value).Type;
            window.location.hash = `admin/dataset/${datasetType}/${datasetName.value}`;
        }
        catch (ex: any)
        {
            new Snack("❌ Failed to create dataset", ex.message);
        }
    }
}
